import { connect } from 'react-redux';
import { actions as notification } from '@skunexus/notification';
import { useRepushProduct } from '../hooks/useRepushProduct';
import * as API from '../api';
import RepushProductModal from '../components/RepushProductModal';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    errorNotification: notification.error,
    successNotification: notification.success,
};

export const withCustomProductDetailsHoc = () => (Component) => {
    function WrappedComponent(props) {
        const { errorNotification, successNotification, params } = props;

        const [{ repushProductModalProps }, { handleOpenRepushProductModal }] = useRepushProduct({
            productId: params.id,
            mutation: API.repushProduct,
            errorNotification,
            successNotification,
        });

        const customActions = (actions = []) => [
            {
                id: 'repush-product',
                icon: 'ArrowRepeat',
                label: 'Repush Product to Magento',
                onClick: handleOpenRepushProductModal,
            },
            ...(actions || []),
        ];

        return (
            <>
                <Component {...props} infoProps={{ customActions }} />
                <RepushProductModal {...repushProductModalProps} />
            </>
        );
    }

    return connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
};
